export enum LocalStorageKey {
    DISMISSED_BANNER = 'DISMISSED_BANNER',
}
